/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Year_BuiltInputs */

const cs_form_year_built = /** @type {(inputs: Form_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok výstavby`)
};

const en_form_year_built = /** @type {(inputs: Form_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year built`)
};

/**
* | output |
* | --- |
* | "Year built" |
*
* @param {Form_Year_BuiltInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_year_built = /** @type {((inputs?: Form_Year_BuiltInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Year_BuiltInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_year_built(inputs)
	return cs_form_year_built(inputs)
});